<template>
  <div id="club">
    <Topbar
      v-if="this.$store.state.topbar_actions_visible"
      @action="fnAction"
    ></Topbar>
    <v-container class="main left">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 sm6 md3 class="logo">
          <img :src="club.shield" />
          <div
            v-if="club.shield"
            class="download"
            @click="downloadImage(club.shield)"
          ></div>
        </v-flex>
        <v-flex xs12 sm6 md9 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <v-flex xs12 class="name">{{ $t("basic_info") }}</v-flex>
              <v-flex xs12 md6>
                <div class="label">{{ $t("params.name") }}:</div>
                <div class="value">{{ club.name | checkParam }}</div>
                <div class="label">{{ $t("params.abbreviation") }}:</div>
                <div class="value">{{ club.abbreviation | checkParam }}</div>
                <div class="label">{{ $t("params.abbreviation_23") }}:</div>
                <div class="value">{{ club.name_abre | checkParam }}</div>
                <div class="label">{{ $t("params.top") }}:</div>
                <div class="value">{{ club.top | checkParam }}</div>
                <div class="label">{{ $t("params.web") }}:</div>
                <div class="value">{{ club.web | checkParam }}</div>
                <div class="label">
                  <Phone :phone="$t('params.phone') + ':'"></Phone>
                </div>
                <div class="value">{{ club.phone | checkParam }}</div>
                <div class="label">
                  <Email :email="$t('params.email') + ':'"></Email>
                </div>
                <div class="value">{{ club.mail | checkParam }}</div>
                <div class="label" v-if="on_event">
                  {{ $t("params.mic_gestor") }}:
                </div>
                <div v-if="on_event" class="value">
                  {{ club.gestor | checkParam }}
                </div>
              </v-flex>
              <v-flex xs12 md6>
                <div class="label">{{ $t("params.address") }}:</div>
                <div class="value">{{ club.address | checkParam }}</div>
                <div class="label">{{ $t("params.city") }}:</div>
                <div class="value">{{ club.city | checkParam }}</div>
                <div class="label">{{ $t("params.cp") }}:</div>
                <div class="value">{{ club.cp | checkParam }}</div>
                <div class="label">{{ $t("params.state") }}:</div>
                <div class="value">{{ club.state | checkParam }}</div>
                <div class="label">{{ $t("params.country") }}:</div>
                <div class="value">
                  <Country v-if="club.country_id" :country="country"></Country>
                </div>
                <!-- if event type id is equal to 15 PUNTA CANA -->
                <template v-if="current_event_type_id == '15'">
                  <div class="label">{{ $t("params.tax_name") }}:</div>
                  <div class="value">{{ club.tax_name | checkParam }}</div>
                  <div class="label">{{ $t("params.tax_id") }}:</div>
                  <div class="value">{{ club.tax_id | checkParam }}</div>
                  <div class="label">{{ $t("params.tax_address") }}:</div>
                  <div class="value">{{ club.tax_address | checkParam }}</div>
                </template>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs12 sm12 md12 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <v-flex
                @click="uniforms_visible = !uniforms_visible"
                xs12
                class="name"
                >{{ $t("uniforms.label") }}</v-flex
              >
              <v-flex xs3 v-for="(uniform, key) in club.uniforms" :key="key">
                <Equipment
                  :equipment="uniform"
                  :number="1"
                  :is_preview="true"
                ></Equipment>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex xs12 sm12 md12 class="info">
          <v-container>
            <v-layout row wrap class="section">
              <v-flex @click="teams_visible = !teams_visible" xs12 class="name">
                {{ $t("teams.label") }}
                <div
                  class="add"
                  v-show="$store.getters.isEventSelected"
                  @click="addTeam"
                >
                  {{ "teams.create.label" | i18n }}
                </div>
              </v-flex>
              <div
                v-show="teams_visible"
                class="event subsection"
                v-for="(event, key) in club.events"
                :key="event.id"
              >
                <div class="title">{{ event.name_show }}</div>
                <TeamCard
                  v-for="(team, k) in event.teams"
                  :show="true"
                  :team="team"
                  :club="club"
                  :event="event"
                  :is_rel="true"
                  :id_rel="club.id"
                  :key="team.id"
                ></TeamCard>
              </div>
            </v-layout>
          </v-container>
        </v-flex>
        <v-flex
          v-if="this.$store.getters.isEventSelected"
          xs12
          sm12
          md12
          class="info"
        >
          <v-container>
            <FinancesCard :page="'club'" :data="club"></FinancesCard>
          </v-container>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="section-container" id="notes">
        <NoteList
          :notes="club.notes"
          :page="'club'"
          :id="id"
          @create_note="createNote"
        ></NoteList>
      </v-layout>
    </v-container>
    <ContactList
      :contacts="club.contacts"
      :entity="'club'"
      class="contact right"
    ></ContactList>
  </div>
</template>

<script>
import i18n from "@/i18n";
import ContactList from "@/components/ui/ContactList";
import NoteList from "@/components/ui/NoteList";
import TeamCard from "@/components/ui/cards/Team";
import Topbar from "@/components/ui/Topbar";
import FinancesCard from "@/components/ui/FinancesCard";
import Phone from "@/components/ui/labels/Phone";
import Email from "@/components/ui/labels/Email";
import Country from "@/components/ui/labels/Country";
import Equipment from "@/components/ui/Equipment";
import LastUpdate from "@/components/ui/LastUpdate";

export default {
  name: "CardClub",
  components: {
    ContactList,
    NoteList,
    TeamCard,
    Topbar,
    Phone,
    Email,
    Country,
    Equipment,
    FinancesCard,
    LastUpdate,
  },
  props: {},
  data() {
    return {
      id: this.$route.params.id,
      //   club: { events: [], notes: [], contacts: [] }
      teams_visible: true,
      uniforms_visible: true,
      current_event_type_id: null
    };
  },
  computed: {
    club() {
      this.$overlay.loading();

      var oClub = {
        ...this.$store.getters["clubs/get_by_id"](this.$route.params.id),
      };
      if (!oClub) oClub = { notes: [] };

      var aEvents = [];
      if (typeof oClub.teams !== "undefined") {
        for (var key in oClub.teams) {
          var team = JSON.parse(JSON.stringify(oClub.teams[key]));
          if (typeof aEvents[team.event.id] === "undefined") {
            team.event.name_show = this.$root.formatEventName(
              team.event.name,
              team.event.edition
            );
            team.event.visible = true;
            aEvents[team.event.id] = team.event;
            aEvents[team.event.id].teams = [];
          }
          aEvents[team.event.id].teams.push({
            id: team.id,
            name: team.name == null ? oClub.name : team.name,
            category: team.category,
            status: team.status,
            players: team.players,
            staff: team.staff,
            acompanyants: team.acompanyants,
          });
        }
      }
      oClub.events = [...ObjectToArray(aEvents)];

      oClub.notes = ObjectToArray(oClub.notes);
      // oClub.notes.sort( function( n1, n2 ){
      //   if( moment( n1.last_update ).valueOf() < moment( n2.last_update ).valueOf() ) return 1
      //   return -1
      // })

      oClub.contacts = ObjectToArray(oClub.contacts);

      if (typeof oClub.gestor_id) {
        var gestor = this.$store.getters["user/getList"](oClub.gestor_id);
        oClub.gestor = typeof gestor !== "undefined" ? gestor.name : "";
      }

      oClub.top = parseInt(oClub.top) == 1;

      this.$overlay.hide();

      return oClub;
    },
    on_event() {
      return this.$store.getters.isEventSelected;
    },

    country() {
      if (this.club.country_id) {
        return { ...this.$store.getters.getCountryByID(this.club.country_id) };
      }
      return {};
    },

    //   contacts() {
    //       return [ { name: 'Manolito García', tel: '2432343248', 'role': 'Responsable', 'email': 'sadsads@sadsd.com' }, { name: 'Mario Martinez', tel: '2432343248', 'role': 'Responsable', 'email': 'sadsads@sadsd.com' } ];
    //   }
  },
  created() {
    this.$overlay.loading();

    this.loadDataPage();
  },
  methods: {
    loadDataPage() {
      this.$store.commit("setTopbarActionsVisible", true);
      this.$store.commit("setMenuVisible", true);

      var oParams = { ...this.$route.params };
      if (this.$store.getters.isEventSelected) {
        oParams.event = this.$store.getters["events/getCurrentEvent"]().id;
      }

      oParams.id = this.$route.params.id;
      this.current_event_type_id = this.$store.getters.isEventSelected
        ? this.$store.getters["events/getCurrentEvent"]().type_id
        : null;
      var self = this;
      this.$store.dispatch("clubs/load_by_id", oParams).then(function () {
        self.$overlay.hide();
      });
    },
    addPayment() {},
    createNote() {
      this.$card.note({
        current_page: "club",
        current_id: this.$route.params.id,
      });
    },

    getCountry(id) {
      if (id) {
        return { ...this.$store.getters.getCountryByID(id) };
      }
      return false;
    },

    fnRemove() {
      var self = this;
      this.$popup.confirm(
        {
          message: i18n.t("clubs.remove_message"),
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel"),
        },
        function () {
          self.$store.dispatch("clubs/remove", self.id).then(function () {
            var event = self.$store.getters.isEventSelected
              ? self.$store.getters["events/getCurrentEvent"]()
              : false;
            var page = event ? "event_" : "";
            page = page + "clubs";

            self.$router.push({
              name: page,
              params: {
                event: event
                  ? self.$root
                      .formatEventUrl(event.name, event.edition)
                      .replace("/event/", "")
                  : null,
              },
            });
          });
        }
      );
    },

    fnAction(emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return;
      switch (emit.action) {
        case "remove":
          this.fnRemove(emit.params);
          break;
        case "create_note":
          this.createNote(emit.params);
          break;
        case "user_create":
          this.fnCreateUser(emit.params);
          break;
        case "rel_club_event":
          this.fnRelClubEvent(emit.params);
          break;
        case "destroy":
          this.fnDestroy(emit.params);
          break;
        case "preview_teamzone":
          this.$root.fnGoToTeamZones(1);
          break;
      }
    },

    fnRemove() {
      var self = this;
      this.$popup.confirm(
        {
          message: i18n.t("clubs.remove_message"),
          btnSuccess: i18n.t("accept"),
          btnError: i18n.t("cancel"),
        },
        function () {
          self.$store.dispatch("clubs/remove", self.id).then(function () {
            var event = self.$store.getters.isEventSelected
              ? self.$store.getters["events/getCurrentEvent"]()
              : false;
            var page = event ? "event_" : "";
            page = page + "clubs";

            self.$router.push({
              name: page,
              params: {
                event: event
                  ? self.$root
                      .formatEventUrl(event.name, event.edition)
                      .replace("/event/", "")
                  : null,
              },
            });
          });
        }
      );
    },
    fnRelClubEvent() {
      if (!this.$store.getters.isEventSelected) {
        var self = this;
        this.$card.relClubEvent({
          club_id: this.$route.params.id,
          event_id: this.$store.getters["events/getCurrentEvent"]().id,
          callBack: function (plug, params, store) {
            self.$store
              .dispatch("clubs/addRelClubEvent", {
                club_id: plug.params.club.value,
                event_id: plug.params.event.value,
                user_id: plug.params.user.value,
              })
              .then(function () {
                self.$popup.alert({
                  message: i18n.t("clubs.created_rel_club_event"),
                  btnSuccess: i18n.t("accept"),
                });
                self.$card.close();
              })
              .catch(function (e) {
                self.$popup.alert({
                  message: i18n.t("errors." + e),
                  btnSuccess: i18n.t("accept"),
                });
              });
          },
        });
      } else {
        this.$popup.alert({
          message: i18n.t("clubs.exist_rel_club_event"),
          btnSuccess: i18n.t("accept"),
        });
      }
    },

    fnCreateUser() {
      var self = this;
      if (
        typeof this.club.mail !== "undefined" &&
        this.club.mail != null &&
        this.club.mail.trim() != ""
      ) {
        self.$store
          .dispatch("clubs/createUserZE", {
            club_id: self.$route.params.id,
            event: this.$store.getters["events/getCurrentEvent"]().id,
          })
          .then(function () {
            self.$popup.alert({
              message: i18n.t("clubs.created_user_teamzone"),
              btnSuccess: i18n.t("accept"),
            });
          })
          .catch(function (e) {
            self.$popup.confirm(
              {
                message: i18n.t("errors." + e),
                btnSuccess: i18n.t("clubs.resend_email"),
                btnError: i18n.t("accept"),
              },
              function () {
                self.$store
                  .dispatch("clubs/resendAccesTeamZone", {
                    club_id: self.$route.params.id,
                    event: self.$store.getters["events/getCurrentEvent"]().id,
                  })
                  .then(function () {
                    self.$comboSelector.close();
                    self.$popup.alert({
                      message:
                        i18n.t("success.email_sended") + " a " + self.club.mail,
                      btnSuccess: i18n.t("accept"),
                    });
                  });
              },
              function () {
                self.$comboSelector.close();
              }
            );
          });
      } else {
        self.$popup.alert({
          message: i18n.t("errors.club_mail_no_valid"),
          btnSuccess: i18n.t("accept"),
        });
      }
    },

    addTeam() {
      var event = this.$store.getters["events/getCurrentEvent"]();
      var event_url = this.$root
        .formatEventUrl(event.name, event.edition)
        .replace("/event/", "");
      this.$router.push({
        name: "event_teams_add",
        params: { event: event_url, club_id: this.$route.params.id },
      });
    },
    fnDestroy() {
      this.$destroy();
    },
    downloadImage(url) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", url);
      document.body.appendChild(link);
      link.click();
    },
  },
  filters: {},
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage",
  },
};
</script>

<style lang="scss" scoped>
#club {
  width: 100%;
  display: inline-block;

  .container {
    width: 80%;
    width: calc(100% - 350px);
    padding: 0px;

    &.main {
      overflow-y: auto;
      height: calc(100vh - 110px);
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }
    }
  }

  .contact {
    width: 20%;
    width: 350px;
    padding: 20px;
  }

  .logo {
    width: 250px;
    height: 250px;
    border: 1px solid #eee;
    position: relative;

    img {
      object-fit: contain;
      object-position: center;
      height: 100%;
      width: auto;
      margin: 0 auto;
      display: block;
    }
    .download {
      width: 40px;
      height: 40px;
      position: absolute;
      background-image: url(/img/download.svg);
      background-color: #000;
      background-size: 30px;
      background-repeat: no-repeat;
      background-position: center;
      top: 0;
      right: 0;
      cursor: pointer;
    }
  }
  .info {
    .container {
      margin: 0;
      padding: 0 20px;
      padding-left: 40px;
      width: 100%;

      .section {
        margin-bottom: 75px;

        .name {
          font-weight: lighter;
          font-size: 24px;
          @include font-size(14px);
          border-bottom: 1px solid #ddd;
          margin: 10px 0 20px 0;
          color: $main-color;
          text-transform: uppercase;
          margin-bottom: 20px;
          padding-bottom: 5px;
          border-bottom: 2px solid $complem-color-dark;
          color: $complem-color-dark;
          position: relative;
          font-family: Roboto-Bold;
        }

        .label {
          font-family: $text-light;
          @include font-size(14px);
          width: 40%;
          float: left;
          line-height: 20px;
        }

        .value {
          font-family: $text;
          font-weight: lighter;
          @include font-size(14px);
          width: 60%;
          float: left;
          margin-bottom: 10px;
        }

        .event.subsection {
          width: 100%;
          cursor: pointer;
          border-left: 5px solid #ddd;
          padding-left: 10px;
          margin: 15px 0;

          .title {
            font-size: 24px !important;
            padding-left: 10px;
          }
        }

        .add {
          background-image: url(/img/add_b.svg);
          background-size: 15px;
          background-repeat: no-repeat;
          background-position: left center;
          position: absolute;
          right: 0;
          top: -5px;
          padding-left: 20px;
          text-transform: none;
          font-weight: bold;
          cursor: pointer;
        }
      }
    }
  }

  #teams {
    .event {
      .title {
        width: fit-content;
        cursor: pointer;

        &::after {
          content: "";
          width: 30px;
          height: 15px;
          background: url(/img/down.svg);
          background-repeat: no-repeat;
          background-size: 15px;
          background-position: center right;
          position: absolute;
        }
      }
    }
  }
}

.alert {
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>
